import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import RenderHTML from "react-native-render-html";
import styled from "styled-components/native";
import { DefaultTheme } from "styled-components/native";
import useScreenOptionsHooks from "../../../../../hooks/useScreenOptionsHooks";
import { useUserAnalytics } from "../../../../../hooks/useAnalytics";
import { ViewTypeEnum } from "@utils/analytics";
import { Linking } from "react-native";
import { VDBIcons } from "@utils/VDBIcons";

const MessageContainer = ({
  statusColor,
  statusIcon,
  statusMessage,
  statusBackgroundColor,
}: {
  statusColor: string;
  statusIcon: VDBIcons;
  statusMessage: string;
  statusBackgroundColor?: string;
}) => {
  const { typography, t, theme } = useScreenOptionsHooks();
  const { trackHyperLinkEvent } = useUserAnalytics() || {};
  return (
    <MessageBanner
      color={statusColor}
      statusBackgroundColor={statusBackgroundColor}
    >
      {statusIcon && (
        <VDBIcon
          name={statusIcon}
          color={statusColor}
          size={20}
          variant={IconsVariant.VDBCustom}
        />
      )}
      <MessageTextContainer>
        <RenderHTML
          source={{ html: t(statusMessage) }}
          renderersProps={{
            a: {
              onPress: (_event: any, href: string) => {
                if (href) {
                  trackHyperLinkEvent?.(
                    href,
                    ViewTypeEnum?.USER_SEATS_SCREEN_VIEW
                  );
                  Linking.openURL(href);
                }
              },
            },
          }}
          tagsStyles={{
            body: {
              ...typography["Minor-M"],
              color: theme["core-05"],
            },
            a: {
              color: theme["link-static"],
              textDecorationLine: "none",
            },
          }}
        />
      </MessageTextContainer>
    </MessageBanner>
  );
};

export default MessageContainer;

const MessageBanner = styled.View<{
  color: string;
  statusBackgroundColor?: string;
}>`
  flex-direction: row;
  align-items: flex-start;
  gap: ${SpaceType.Basic}px;
  padding: ${SpaceType.Extra}px ${SpaceType.Double}px;
  background-color: ${({
    theme,
    statusBackgroundColor,
  }: {
    theme: DefaultTheme;
    statusBackgroundColor?: string;
  }) => statusBackgroundColor || theme["core-01"]};
  border-radius: ${SpaceType.Basic}px;
  align-items: center;
`;

const MessageTextContainer = styled.View`
  flex: 1;
`;
